import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

import { EmailPopoverComponent } from './email-popover/email-popover';
import { TemplateChannelPickerPopover } from './template-channel-picker/template-channel-picker.popover';

// EmailPopoverComponent is kept NgModule-declared because email-activity-detail.ts
// statically imports it for popoverController.create — email-activity-detail is
// declared in ActivityModule (eager), anchoring this component in main.js.
// Making it standalone with imports:[SharedModule] risks TDZ circular-init at runtime.
// TemplateChannelPickerPopover is similarly kept here — it's a non-standalone popover
// instantiated via popoverController.create from email-template-details.ts.
@NgModule({
  imports: [SharedModule],
  declarations: [EmailPopoverComponent, TemplateChannelPickerPopover],
  exports: [EmailPopoverComponent, TemplateChannelPickerPopover],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EmailModule {}
